import { render } from "./v-child-details.vue?vue&type=template&id=59c4f164"
import script from "./v-child-details.vue?vue&type=script&lang=js"
export * from "./v-child-details.vue?vue&type=script&lang=js"

import "./v-child-details.vue?vue&type=style&index=0&id=59c4f164&lang=css"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__